export class Customer {
    constructor(public customer : string){
        
    }
}
